import {Suspense} from "react";

const withSuspense = <T extends {}>(
	Component: React.ComponentType<T>,
	fallback?: React.ReactElement
) => {
	const ComponentWithSuspense: React.FC<T> = (props) => (
		<Suspense fallback={fallback}>
			<Component {...props} />
		</Suspense>
	);
	return ComponentWithSuspense;
};

export default withSuspense;
